const LoginInfo = {
  token: null,
  info: null
}

export function getToken() {
  return LoginInfo.token
}

export function setInfo(info) {
  LoginInfo.token = `${info.token}`
  LoginInfo.info = info
}

export function setToken(token) {
  LoginInfo.token = token
}

export function removeToken() {
  LoginInfo.info = null
  LoginInfo.token = null
}
